/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createUnit = /* GraphQL */ `mutation CreateUnit(
  $input: CreateUnitInput!
  $condition: ModelUnitConditionInput
) {
  createUnit(input: $input, condition: $condition) {
    id
    facilityID
    size
    usage
    price
    tenantID
    boxes {
      items {
        id
        tenantID
        facilityID
        unitID
        description
        status
        photo
        location
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    unitID
    availability
    sitelinkUnit {
      Ret_Code
      UnitTypeID
      sTypeName
      iDefLeaseNum
      UnitID
      sUnitName
      dcWidth
      dcLength
      dcStdRate
      bRented
      bRentable
      sUnitDesc
      bWaitingListReserved
      DefaultCoverageID
      SiteID
      dcBoardRate
      dcPreferredRate
      dcPushRate
      dcPushRate_NotRounded
      dcStdSecDep
      dcStdWeeklyRate
      dcWebRate
      iDaysVacant
      iFloor
      sLocationCode
      bClimate
      bInside
      bPower
      bAlarm
      dMovedOut
      bCorporate
      dDeleted
      sUnitNote
      dcTax1Rate
      dcTax2Rate
      dcMapTop
      dcMapLeft
      dcMapTheta
      bMapReversWL
      iEntryLoc
      iDoorType
      iADA
      bMobile
      dcRM_RoundTo
      bServiceRequired
      bExcludeFromWebsite
      iPreferredChannelType
      bPreferredIsPushRate
      __typename
    }
    createdAt
    updatedAt
    tenant {
      items {
        id
        facilityID
        name
        email
        phone
        unitID
        address {
          tenantID
          addressLine1
          addressLine2
          city
          state
          zip
          specialInstructions
          building
          parking
          __typename
        }
        licenseNumber
        licenseState
        boxes {
          items {
            id
            tenantID
            facilityID
            unitID
            description
            status
            photo
            location
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        plan {
          minStay
          typeOfPlan
          size
          price
          __typename
        }
        ledgerIDs
        tenantID
        accessCode
        stripeCustomerID
        stripeStatus
        card {
          id
          nickname
          __typename
        }
        referralCode
        createdAt
        updatedAt
        orders {
          items {
            id
            tenantID
            facilityID
            date
            time
            jobType
            status
            driver
            needHelp
            needPack
            moverOption
            orderItems
            movingTime
            movingFee
            isInitialOrder
            chosenSlotPaid
            chosenSlotPrice
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUnitMutationVariables,
  APITypes.CreateUnitMutation
>;
export const updateUnit = /* GraphQL */ `mutation UpdateUnit(
  $input: UpdateUnitInput!
  $condition: ModelUnitConditionInput
) {
  updateUnit(input: $input, condition: $condition) {
    id
    facilityID
    size
    usage
    price
    tenantID
    boxes {
      items {
        id
        tenantID
        facilityID
        unitID
        description
        status
        photo
        location
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    unitID
    availability
    sitelinkUnit {
      Ret_Code
      UnitTypeID
      sTypeName
      iDefLeaseNum
      UnitID
      sUnitName
      dcWidth
      dcLength
      dcStdRate
      bRented
      bRentable
      sUnitDesc
      bWaitingListReserved
      DefaultCoverageID
      SiteID
      dcBoardRate
      dcPreferredRate
      dcPushRate
      dcPushRate_NotRounded
      dcStdSecDep
      dcStdWeeklyRate
      dcWebRate
      iDaysVacant
      iFloor
      sLocationCode
      bClimate
      bInside
      bPower
      bAlarm
      dMovedOut
      bCorporate
      dDeleted
      sUnitNote
      dcTax1Rate
      dcTax2Rate
      dcMapTop
      dcMapLeft
      dcMapTheta
      bMapReversWL
      iEntryLoc
      iDoorType
      iADA
      bMobile
      dcRM_RoundTo
      bServiceRequired
      bExcludeFromWebsite
      iPreferredChannelType
      bPreferredIsPushRate
      __typename
    }
    createdAt
    updatedAt
    tenant {
      items {
        id
        facilityID
        name
        email
        phone
        unitID
        address {
          tenantID
          addressLine1
          addressLine2
          city
          state
          zip
          specialInstructions
          building
          parking
          __typename
        }
        licenseNumber
        licenseState
        boxes {
          items {
            id
            tenantID
            facilityID
            unitID
            description
            status
            photo
            location
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        plan {
          minStay
          typeOfPlan
          size
          price
          __typename
        }
        ledgerIDs
        tenantID
        accessCode
        stripeCustomerID
        stripeStatus
        card {
          id
          nickname
          __typename
        }
        referralCode
        createdAt
        updatedAt
        orders {
          items {
            id
            tenantID
            facilityID
            date
            time
            jobType
            status
            driver
            needHelp
            needPack
            moverOption
            orderItems
            movingTime
            movingFee
            isInitialOrder
            chosenSlotPaid
            chosenSlotPrice
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUnitMutationVariables,
  APITypes.UpdateUnitMutation
>;
export const deleteUnit = /* GraphQL */ `mutation DeleteUnit(
  $input: DeleteUnitInput!
  $condition: ModelUnitConditionInput
) {
  deleteUnit(input: $input, condition: $condition) {
    id
    facilityID
    size
    usage
    price
    tenantID
    boxes {
      items {
        id
        tenantID
        facilityID
        unitID
        description
        status
        photo
        location
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    unitID
    availability
    sitelinkUnit {
      Ret_Code
      UnitTypeID
      sTypeName
      iDefLeaseNum
      UnitID
      sUnitName
      dcWidth
      dcLength
      dcStdRate
      bRented
      bRentable
      sUnitDesc
      bWaitingListReserved
      DefaultCoverageID
      SiteID
      dcBoardRate
      dcPreferredRate
      dcPushRate
      dcPushRate_NotRounded
      dcStdSecDep
      dcStdWeeklyRate
      dcWebRate
      iDaysVacant
      iFloor
      sLocationCode
      bClimate
      bInside
      bPower
      bAlarm
      dMovedOut
      bCorporate
      dDeleted
      sUnitNote
      dcTax1Rate
      dcTax2Rate
      dcMapTop
      dcMapLeft
      dcMapTheta
      bMapReversWL
      iEntryLoc
      iDoorType
      iADA
      bMobile
      dcRM_RoundTo
      bServiceRequired
      bExcludeFromWebsite
      iPreferredChannelType
      bPreferredIsPushRate
      __typename
    }
    createdAt
    updatedAt
    tenant {
      items {
        id
        facilityID
        name
        email
        phone
        unitID
        address {
          tenantID
          addressLine1
          addressLine2
          city
          state
          zip
          specialInstructions
          building
          parking
          __typename
        }
        licenseNumber
        licenseState
        boxes {
          items {
            id
            tenantID
            facilityID
            unitID
            description
            status
            photo
            location
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        plan {
          minStay
          typeOfPlan
          size
          price
          __typename
        }
        ledgerIDs
        tenantID
        accessCode
        stripeCustomerID
        stripeStatus
        card {
          id
          nickname
          __typename
        }
        referralCode
        createdAt
        updatedAt
        orders {
          items {
            id
            tenantID
            facilityID
            date
            time
            jobType
            status
            driver
            needHelp
            needPack
            moverOption
            orderItems
            movingTime
            movingFee
            isInitialOrder
            chosenSlotPaid
            chosenSlotPrice
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUnitMutationVariables,
  APITypes.DeleteUnitMutation
>;
export const createAdmin = /* GraphQL */ `mutation CreateAdmin(
  $input: CreateAdminInput!
  $condition: ModelAdminConditionInput
) {
  createAdmin(input: $input, condition: $condition) {
    id
    name
    createdAt
    updatedAt
    facility {
      items {
        id
        name
        address
        boxes {
          items {
            id
            tenantID
            facilityID
            unitID
            description
            status
            photo
            location
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        units {
          items {
            id
            facilityID
            size
            usage
            price
            tenantID
            unitID
            availability
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        drivers {
          items {
            id
            facilityID
            name
            availability
            googleCalendarUrl
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        appointments {
          items {
            facilityID
            id
            date
            time
            source
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        movingCosts {
          flatFee
          hourlyFee
          __typename
        }
        scheduleConfig {
          slots {
            time
            freeCount
            paidCount
            __typename
          }
          pricingSmall {
            flatFee
            perMinFee
            __typename
          }
          pricingLarge {
            flatFee
            perMinFee
            __typename
          }
          freeLabel
          __typename
        }
        createdAt
        updatedAt
        customers {
          items {
            id
            facilityID
            name
            email
            phone
            unitID
            licenseNumber
            licenseState
            ledgerIDs
            tenantID
            accessCode
            stripeCustomerID
            stripeStatus
            referralCode
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orders {
          items {
            id
            tenantID
            facilityID
            date
            time
            jobType
            status
            driver
            needHelp
            needPack
            moverOption
            orderItems
            movingTime
            movingFee
            isInitialOrder
            chosenSlotPaid
            chosenSlotPrice
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        plans {
          items {
            id
            facilityID
            type
            minStay
            photo
            size
            price
            ft
            description
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAdminMutationVariables,
  APITypes.CreateAdminMutation
>;
export const updateAdmin = /* GraphQL */ `mutation UpdateAdmin(
  $input: UpdateAdminInput!
  $condition: ModelAdminConditionInput
) {
  updateAdmin(input: $input, condition: $condition) {
    id
    name
    createdAt
    updatedAt
    facility {
      items {
        id
        name
        address
        boxes {
          items {
            id
            tenantID
            facilityID
            unitID
            description
            status
            photo
            location
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        units {
          items {
            id
            facilityID
            size
            usage
            price
            tenantID
            unitID
            availability
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        drivers {
          items {
            id
            facilityID
            name
            availability
            googleCalendarUrl
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        appointments {
          items {
            facilityID
            id
            date
            time
            source
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        movingCosts {
          flatFee
          hourlyFee
          __typename
        }
        scheduleConfig {
          slots {
            time
            freeCount
            paidCount
            __typename
          }
          pricingSmall {
            flatFee
            perMinFee
            __typename
          }
          pricingLarge {
            flatFee
            perMinFee
            __typename
          }
          freeLabel
          __typename
        }
        createdAt
        updatedAt
        customers {
          items {
            id
            facilityID
            name
            email
            phone
            unitID
            licenseNumber
            licenseState
            ledgerIDs
            tenantID
            accessCode
            stripeCustomerID
            stripeStatus
            referralCode
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orders {
          items {
            id
            tenantID
            facilityID
            date
            time
            jobType
            status
            driver
            needHelp
            needPack
            moverOption
            orderItems
            movingTime
            movingFee
            isInitialOrder
            chosenSlotPaid
            chosenSlotPrice
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        plans {
          items {
            id
            facilityID
            type
            minStay
            photo
            size
            price
            ft
            description
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAdminMutationVariables,
  APITypes.UpdateAdminMutation
>;
export const deleteAdmin = /* GraphQL */ `mutation DeleteAdmin(
  $input: DeleteAdminInput!
  $condition: ModelAdminConditionInput
) {
  deleteAdmin(input: $input, condition: $condition) {
    id
    name
    createdAt
    updatedAt
    facility {
      items {
        id
        name
        address
        boxes {
          items {
            id
            tenantID
            facilityID
            unitID
            description
            status
            photo
            location
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        units {
          items {
            id
            facilityID
            size
            usage
            price
            tenantID
            unitID
            availability
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        drivers {
          items {
            id
            facilityID
            name
            availability
            googleCalendarUrl
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        appointments {
          items {
            facilityID
            id
            date
            time
            source
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        movingCosts {
          flatFee
          hourlyFee
          __typename
        }
        scheduleConfig {
          slots {
            time
            freeCount
            paidCount
            __typename
          }
          pricingSmall {
            flatFee
            perMinFee
            __typename
          }
          pricingLarge {
            flatFee
            perMinFee
            __typename
          }
          freeLabel
          __typename
        }
        createdAt
        updatedAt
        customers {
          items {
            id
            facilityID
            name
            email
            phone
            unitID
            licenseNumber
            licenseState
            ledgerIDs
            tenantID
            accessCode
            stripeCustomerID
            stripeStatus
            referralCode
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        orders {
          items {
            id
            tenantID
            facilityID
            date
            time
            jobType
            status
            driver
            needHelp
            needPack
            moverOption
            orderItems
            movingTime
            movingFee
            isInitialOrder
            chosenSlotPaid
            chosenSlotPrice
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        plans {
          items {
            id
            facilityID
            type
            minStay
            photo
            size
            price
            ft
            description
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAdminMutationVariables,
  APITypes.DeleteAdminMutation
>;
export const createDriver = /* GraphQL */ `mutation CreateDriver(
  $input: CreateDriverInput!
  $condition: ModelDriverConditionInput
) {
  createDriver(input: $input, condition: $condition) {
    id
    facilityID
    name
    availability
    googleCalendarUrl
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDriverMutationVariables,
  APITypes.CreateDriverMutation
>;
export const updateDriver = /* GraphQL */ `mutation UpdateDriver(
  $input: UpdateDriverInput!
  $condition: ModelDriverConditionInput
) {
  updateDriver(input: $input, condition: $condition) {
    id
    facilityID
    name
    availability
    googleCalendarUrl
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDriverMutationVariables,
  APITypes.UpdateDriverMutation
>;
export const deleteDriver = /* GraphQL */ `mutation DeleteDriver(
  $input: DeleteDriverInput!
  $condition: ModelDriverConditionInput
) {
  deleteDriver(input: $input, condition: $condition) {
    id
    facilityID
    name
    availability
    googleCalendarUrl
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDriverMutationVariables,
  APITypes.DeleteDriverMutation
>;
export const createBox = /* GraphQL */ `mutation CreateBox(
  $input: CreateBoxInput!
  $condition: ModelBoxConditionInput
) {
  createBox(input: $input, condition: $condition) {
    id
    tenantID
    facilityID
    unitID
    description
    status
    photo
    location
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateBoxMutationVariables,
  APITypes.CreateBoxMutation
>;
export const updateBox = /* GraphQL */ `mutation UpdateBox(
  $input: UpdateBoxInput!
  $condition: ModelBoxConditionInput
) {
  updateBox(input: $input, condition: $condition) {
    id
    tenantID
    facilityID
    unitID
    description
    status
    photo
    location
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateBoxMutationVariables,
  APITypes.UpdateBoxMutation
>;
export const deleteBox = /* GraphQL */ `mutation DeleteBox(
  $input: DeleteBoxInput!
  $condition: ModelBoxConditionInput
) {
  deleteBox(input: $input, condition: $condition) {
    id
    tenantID
    facilityID
    unitID
    description
    status
    photo
    location
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteBoxMutationVariables,
  APITypes.DeleteBoxMutation
>;
export const createAppointment = /* GraphQL */ `mutation CreateAppointment(
  $input: CreateAppointmentInput!
  $condition: ModelAppointmentConditionInput
) {
  createAppointment(input: $input, condition: $condition) {
    facilityID
    id
    date
    time
    source
    createdAt
    updatedAt
    order {
      id
      tenantID
      facilityID
      date
      time
      address {
        tenantID
        addressLine1
        addressLine2
        city
        state
        zip
        specialInstructions
        building
        parking
        __typename
      }
      jobType
      status
      driver
      needHelp
      needPack
      moverOption
      orderItems
      movingTime
      movingFee
      isInitialOrder
      chosenSlotPaid
      chosenSlotPrice
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAppointmentMutationVariables,
  APITypes.CreateAppointmentMutation
>;
export const updateAppointment = /* GraphQL */ `mutation UpdateAppointment(
  $input: UpdateAppointmentInput!
  $condition: ModelAppointmentConditionInput
) {
  updateAppointment(input: $input, condition: $condition) {
    facilityID
    id
    date
    time
    source
    createdAt
    updatedAt
    order {
      id
      tenantID
      facilityID
      date
      time
      address {
        tenantID
        addressLine1
        addressLine2
        city
        state
        zip
        specialInstructions
        building
        parking
        __typename
      }
      jobType
      status
      driver
      needHelp
      needPack
      moverOption
      orderItems
      movingTime
      movingFee
      isInitialOrder
      chosenSlotPaid
      chosenSlotPrice
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAppointmentMutationVariables,
  APITypes.UpdateAppointmentMutation
>;
export const deleteAppointment = /* GraphQL */ `mutation DeleteAppointment(
  $input: DeleteAppointmentInput!
  $condition: ModelAppointmentConditionInput
) {
  deleteAppointment(input: $input, condition: $condition) {
    facilityID
    id
    date
    time
    source
    createdAt
    updatedAt
    order {
      id
      tenantID
      facilityID
      date
      time
      address {
        tenantID
        addressLine1
        addressLine2
        city
        state
        zip
        specialInstructions
        building
        parking
        __typename
      }
      jobType
      status
      driver
      needHelp
      needPack
      moverOption
      orderItems
      movingTime
      movingFee
      isInitialOrder
      chosenSlotPaid
      chosenSlotPrice
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAppointmentMutationVariables,
  APITypes.DeleteAppointmentMutation
>;
export const createFacility = /* GraphQL */ `mutation CreateFacility(
  $input: CreateFacilityInput!
  $condition: ModelFacilityConditionInput
) {
  createFacility(input: $input, condition: $condition) {
    id
    name
    address
    boxes {
      items {
        id
        tenantID
        facilityID
        unitID
        description
        status
        photo
        location
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    units {
      items {
        id
        facilityID
        size
        usage
        price
        tenantID
        boxes {
          items {
            id
            tenantID
            facilityID
            unitID
            description
            status
            photo
            location
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        unitID
        availability
        sitelinkUnit {
          Ret_Code
          UnitTypeID
          sTypeName
          iDefLeaseNum
          UnitID
          sUnitName
          dcWidth
          dcLength
          dcStdRate
          bRented
          bRentable
          sUnitDesc
          bWaitingListReserved
          DefaultCoverageID
          SiteID
          dcBoardRate
          dcPreferredRate
          dcPushRate
          dcPushRate_NotRounded
          dcStdSecDep
          dcStdWeeklyRate
          dcWebRate
          iDaysVacant
          iFloor
          sLocationCode
          bClimate
          bInside
          bPower
          bAlarm
          dMovedOut
          bCorporate
          dDeleted
          sUnitNote
          dcTax1Rate
          dcTax2Rate
          dcMapTop
          dcMapLeft
          dcMapTheta
          bMapReversWL
          iEntryLoc
          iDoorType
          iADA
          bMobile
          dcRM_RoundTo
          bServiceRequired
          bExcludeFromWebsite
          iPreferredChannelType
          bPreferredIsPushRate
          __typename
        }
        createdAt
        updatedAt
        tenant {
          items {
            id
            facilityID
            name
            email
            phone
            unitID
            licenseNumber
            licenseState
            ledgerIDs
            tenantID
            accessCode
            stripeCustomerID
            stripeStatus
            referralCode
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
    drivers {
      items {
        id
        facilityID
        name
        availability
        googleCalendarUrl
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    appointments {
      items {
        facilityID
        id
        date
        time
        source
        createdAt
        updatedAt
        order {
          id
          tenantID
          facilityID
          date
          time
          address {
            tenantID
            addressLine1
            addressLine2
            city
            state
            zip
            specialInstructions
            building
            parking
            __typename
          }
          jobType
          status
          driver
          needHelp
          needPack
          moverOption
          orderItems
          movingTime
          movingFee
          isInitialOrder
          chosenSlotPaid
          chosenSlotPrice
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
    movingCosts {
      flatFee
      hourlyFee
      __typename
    }
    scheduleConfig {
      slots {
        time
        freeCount
        paidCount
        __typename
      }
      pricingSmall {
        flatFee
        perMinFee
        __typename
      }
      pricingLarge {
        flatFee
        perMinFee
        __typename
      }
      freeLabel
      __typename
    }
    createdAt
    updatedAt
    customers {
      items {
        id
        facilityID
        name
        email
        phone
        unitID
        address {
          tenantID
          addressLine1
          addressLine2
          city
          state
          zip
          specialInstructions
          building
          parking
          __typename
        }
        licenseNumber
        licenseState
        boxes {
          items {
            id
            tenantID
            facilityID
            unitID
            description
            status
            photo
            location
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        plan {
          minStay
          typeOfPlan
          size
          price
          __typename
        }
        ledgerIDs
        tenantID
        accessCode
        stripeCustomerID
        stripeStatus
        card {
          id
          nickname
          __typename
        }
        referralCode
        createdAt
        updatedAt
        orders {
          items {
            id
            tenantID
            facilityID
            date
            time
            jobType
            status
            driver
            needHelp
            needPack
            moverOption
            orderItems
            movingTime
            movingFee
            isInitialOrder
            chosenSlotPaid
            chosenSlotPrice
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
    orders {
      items {
        id
        tenantID
        facilityID
        date
        time
        address {
          tenantID
          addressLine1
          addressLine2
          city
          state
          zip
          specialInstructions
          building
          parking
          __typename
        }
        jobType
        status
        driver
        needHelp
        needPack
        moverOption
        orderItems
        movingTime
        movingFee
        isInitialOrder
        chosenSlotPaid
        chosenSlotPrice
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    plans {
      items {
        id
        facilityID
        type
        minStay
        photo
        size
        price
        ft
        description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFacilityMutationVariables,
  APITypes.CreateFacilityMutation
>;
export const updateFacility = /* GraphQL */ `mutation UpdateFacility(
  $input: UpdateFacilityInput!
  $condition: ModelFacilityConditionInput
) {
  updateFacility(input: $input, condition: $condition) {
    id
    name
    address
    boxes {
      items {
        id
        tenantID
        facilityID
        unitID
        description
        status
        photo
        location
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    units {
      items {
        id
        facilityID
        size
        usage
        price
        tenantID
        boxes {
          items {
            id
            tenantID
            facilityID
            unitID
            description
            status
            photo
            location
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        unitID
        availability
        sitelinkUnit {
          Ret_Code
          UnitTypeID
          sTypeName
          iDefLeaseNum
          UnitID
          sUnitName
          dcWidth
          dcLength
          dcStdRate
          bRented
          bRentable
          sUnitDesc
          bWaitingListReserved
          DefaultCoverageID
          SiteID
          dcBoardRate
          dcPreferredRate
          dcPushRate
          dcPushRate_NotRounded
          dcStdSecDep
          dcStdWeeklyRate
          dcWebRate
          iDaysVacant
          iFloor
          sLocationCode
          bClimate
          bInside
          bPower
          bAlarm
          dMovedOut
          bCorporate
          dDeleted
          sUnitNote
          dcTax1Rate
          dcTax2Rate
          dcMapTop
          dcMapLeft
          dcMapTheta
          bMapReversWL
          iEntryLoc
          iDoorType
          iADA
          bMobile
          dcRM_RoundTo
          bServiceRequired
          bExcludeFromWebsite
          iPreferredChannelType
          bPreferredIsPushRate
          __typename
        }
        createdAt
        updatedAt
        tenant {
          items {
            id
            facilityID
            name
            email
            phone
            unitID
            licenseNumber
            licenseState
            ledgerIDs
            tenantID
            accessCode
            stripeCustomerID
            stripeStatus
            referralCode
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
    drivers {
      items {
        id
        facilityID
        name
        availability
        googleCalendarUrl
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    appointments {
      items {
        facilityID
        id
        date
        time
        source
        createdAt
        updatedAt
        order {
          id
          tenantID
          facilityID
          date
          time
          address {
            tenantID
            addressLine1
            addressLine2
            city
            state
            zip
            specialInstructions
            building
            parking
            __typename
          }
          jobType
          status
          driver
          needHelp
          needPack
          moverOption
          orderItems
          movingTime
          movingFee
          isInitialOrder
          chosenSlotPaid
          chosenSlotPrice
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
    movingCosts {
      flatFee
      hourlyFee
      __typename
    }
    scheduleConfig {
      slots {
        time
        freeCount
        paidCount
        __typename
      }
      pricingSmall {
        flatFee
        perMinFee
        __typename
      }
      pricingLarge {
        flatFee
        perMinFee
        __typename
      }
      freeLabel
      __typename
    }
    createdAt
    updatedAt
    customers {
      items {
        id
        facilityID
        name
        email
        phone
        unitID
        address {
          tenantID
          addressLine1
          addressLine2
          city
          state
          zip
          specialInstructions
          building
          parking
          __typename
        }
        licenseNumber
        licenseState
        boxes {
          items {
            id
            tenantID
            facilityID
            unitID
            description
            status
            photo
            location
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        plan {
          minStay
          typeOfPlan
          size
          price
          __typename
        }
        ledgerIDs
        tenantID
        accessCode
        stripeCustomerID
        stripeStatus
        card {
          id
          nickname
          __typename
        }
        referralCode
        createdAt
        updatedAt
        orders {
          items {
            id
            tenantID
            facilityID
            date
            time
            jobType
            status
            driver
            needHelp
            needPack
            moverOption
            orderItems
            movingTime
            movingFee
            isInitialOrder
            chosenSlotPaid
            chosenSlotPrice
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
    orders {
      items {
        id
        tenantID
        facilityID
        date
        time
        address {
          tenantID
          addressLine1
          addressLine2
          city
          state
          zip
          specialInstructions
          building
          parking
          __typename
        }
        jobType
        status
        driver
        needHelp
        needPack
        moverOption
        orderItems
        movingTime
        movingFee
        isInitialOrder
        chosenSlotPaid
        chosenSlotPrice
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    plans {
      items {
        id
        facilityID
        type
        minStay
        photo
        size
        price
        ft
        description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFacilityMutationVariables,
  APITypes.UpdateFacilityMutation
>;
export const deleteFacility = /* GraphQL */ `mutation DeleteFacility(
  $input: DeleteFacilityInput!
  $condition: ModelFacilityConditionInput
) {
  deleteFacility(input: $input, condition: $condition) {
    id
    name
    address
    boxes {
      items {
        id
        tenantID
        facilityID
        unitID
        description
        status
        photo
        location
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    units {
      items {
        id
        facilityID
        size
        usage
        price
        tenantID
        boxes {
          items {
            id
            tenantID
            facilityID
            unitID
            description
            status
            photo
            location
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        unitID
        availability
        sitelinkUnit {
          Ret_Code
          UnitTypeID
          sTypeName
          iDefLeaseNum
          UnitID
          sUnitName
          dcWidth
          dcLength
          dcStdRate
          bRented
          bRentable
          sUnitDesc
          bWaitingListReserved
          DefaultCoverageID
          SiteID
          dcBoardRate
          dcPreferredRate
          dcPushRate
          dcPushRate_NotRounded
          dcStdSecDep
          dcStdWeeklyRate
          dcWebRate
          iDaysVacant
          iFloor
          sLocationCode
          bClimate
          bInside
          bPower
          bAlarm
          dMovedOut
          bCorporate
          dDeleted
          sUnitNote
          dcTax1Rate
          dcTax2Rate
          dcMapTop
          dcMapLeft
          dcMapTheta
          bMapReversWL
          iEntryLoc
          iDoorType
          iADA
          bMobile
          dcRM_RoundTo
          bServiceRequired
          bExcludeFromWebsite
          iPreferredChannelType
          bPreferredIsPushRate
          __typename
        }
        createdAt
        updatedAt
        tenant {
          items {
            id
            facilityID
            name
            email
            phone
            unitID
            licenseNumber
            licenseState
            ledgerIDs
            tenantID
            accessCode
            stripeCustomerID
            stripeStatus
            referralCode
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
    drivers {
      items {
        id
        facilityID
        name
        availability
        googleCalendarUrl
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    appointments {
      items {
        facilityID
        id
        date
        time
        source
        createdAt
        updatedAt
        order {
          id
          tenantID
          facilityID
          date
          time
          address {
            tenantID
            addressLine1
            addressLine2
            city
            state
            zip
            specialInstructions
            building
            parking
            __typename
          }
          jobType
          status
          driver
          needHelp
          needPack
          moverOption
          orderItems
          movingTime
          movingFee
          isInitialOrder
          chosenSlotPaid
          chosenSlotPrice
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
    movingCosts {
      flatFee
      hourlyFee
      __typename
    }
    scheduleConfig {
      slots {
        time
        freeCount
        paidCount
        __typename
      }
      pricingSmall {
        flatFee
        perMinFee
        __typename
      }
      pricingLarge {
        flatFee
        perMinFee
        __typename
      }
      freeLabel
      __typename
    }
    createdAt
    updatedAt
    customers {
      items {
        id
        facilityID
        name
        email
        phone
        unitID
        address {
          tenantID
          addressLine1
          addressLine2
          city
          state
          zip
          specialInstructions
          building
          parking
          __typename
        }
        licenseNumber
        licenseState
        boxes {
          items {
            id
            tenantID
            facilityID
            unitID
            description
            status
            photo
            location
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        plan {
          minStay
          typeOfPlan
          size
          price
          __typename
        }
        ledgerIDs
        tenantID
        accessCode
        stripeCustomerID
        stripeStatus
        card {
          id
          nickname
          __typename
        }
        referralCode
        createdAt
        updatedAt
        orders {
          items {
            id
            tenantID
            facilityID
            date
            time
            jobType
            status
            driver
            needHelp
            needPack
            moverOption
            orderItems
            movingTime
            movingFee
            isInitialOrder
            chosenSlotPaid
            chosenSlotPrice
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
    orders {
      items {
        id
        tenantID
        facilityID
        date
        time
        address {
          tenantID
          addressLine1
          addressLine2
          city
          state
          zip
          specialInstructions
          building
          parking
          __typename
        }
        jobType
        status
        driver
        needHelp
        needPack
        moverOption
        orderItems
        movingTime
        movingFee
        isInitialOrder
        chosenSlotPaid
        chosenSlotPrice
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    plans {
      items {
        id
        facilityID
        type
        minStay
        photo
        size
        price
        ft
        description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteFacilityMutationVariables,
  APITypes.DeleteFacilityMutation
>;
export const createZipcodes = /* GraphQL */ `mutation CreateZipcodes(
  $input: CreateZipcodesInput!
  $condition: ModelZipcodesConditionInput
) {
  createZipcodes(input: $input, condition: $condition) {
    id
    zipcodes
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateZipcodesMutationVariables,
  APITypes.CreateZipcodesMutation
>;
export const updateZipcodes = /* GraphQL */ `mutation UpdateZipcodes(
  $input: UpdateZipcodesInput!
  $condition: ModelZipcodesConditionInput
) {
  updateZipcodes(input: $input, condition: $condition) {
    id
    zipcodes
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateZipcodesMutationVariables,
  APITypes.UpdateZipcodesMutation
>;
export const deleteZipcodes = /* GraphQL */ `mutation DeleteZipcodes(
  $input: DeleteZipcodesInput!
  $condition: ModelZipcodesConditionInput
) {
  deleteZipcodes(input: $input, condition: $condition) {
    id
    zipcodes
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteZipcodesMutationVariables,
  APITypes.DeleteZipcodesMutation
>;
export const createTenant = /* GraphQL */ `mutation CreateTenant(
  $input: CreateTenantInput!
  $condition: ModelTenantConditionInput
) {
  createTenant(input: $input, condition: $condition) {
    id
    facilityID
    name
    email
    phone
    unitID
    address {
      tenantID
      addressLine1
      addressLine2
      city
      state
      zip
      specialInstructions
      building
      parking
      __typename
    }
    licenseNumber
    licenseState
    boxes {
      items {
        id
        tenantID
        facilityID
        unitID
        description
        status
        photo
        location
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    plan {
      minStay
      typeOfPlan
      size
      price
      __typename
    }
    ledgerIDs
    tenantID
    accessCode
    stripeCustomerID
    stripeStatus
    card {
      id
      nickname
      __typename
    }
    referralCode
    createdAt
    updatedAt
    orders {
      items {
        id
        tenantID
        facilityID
        date
        time
        address {
          tenantID
          addressLine1
          addressLine2
          city
          state
          zip
          specialInstructions
          building
          parking
          __typename
        }
        jobType
        status
        driver
        needHelp
        needPack
        moverOption
        orderItems
        movingTime
        movingFee
        isInitialOrder
        chosenSlotPaid
        chosenSlotPrice
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTenantMutationVariables,
  APITypes.CreateTenantMutation
>;
export const updateTenant = /* GraphQL */ `mutation UpdateTenant(
  $input: UpdateTenantInput!
  $condition: ModelTenantConditionInput
) {
  updateTenant(input: $input, condition: $condition) {
    id
    facilityID
    name
    email
    phone
    unitID
    address {
      tenantID
      addressLine1
      addressLine2
      city
      state
      zip
      specialInstructions
      building
      parking
      __typename
    }
    licenseNumber
    licenseState
    boxes {
      items {
        id
        tenantID
        facilityID
        unitID
        description
        status
        photo
        location
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    plan {
      minStay
      typeOfPlan
      size
      price
      __typename
    }
    ledgerIDs
    tenantID
    accessCode
    stripeCustomerID
    stripeStatus
    card {
      id
      nickname
      __typename
    }
    referralCode
    createdAt
    updatedAt
    orders {
      items {
        id
        tenantID
        facilityID
        date
        time
        address {
          tenantID
          addressLine1
          addressLine2
          city
          state
          zip
          specialInstructions
          building
          parking
          __typename
        }
        jobType
        status
        driver
        needHelp
        needPack
        moverOption
        orderItems
        movingTime
        movingFee
        isInitialOrder
        chosenSlotPaid
        chosenSlotPrice
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTenantMutationVariables,
  APITypes.UpdateTenantMutation
>;
export const deleteTenant = /* GraphQL */ `mutation DeleteTenant(
  $input: DeleteTenantInput!
  $condition: ModelTenantConditionInput
) {
  deleteTenant(input: $input, condition: $condition) {
    id
    facilityID
    name
    email
    phone
    unitID
    address {
      tenantID
      addressLine1
      addressLine2
      city
      state
      zip
      specialInstructions
      building
      parking
      __typename
    }
    licenseNumber
    licenseState
    boxes {
      items {
        id
        tenantID
        facilityID
        unitID
        description
        status
        photo
        location
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    plan {
      minStay
      typeOfPlan
      size
      price
      __typename
    }
    ledgerIDs
    tenantID
    accessCode
    stripeCustomerID
    stripeStatus
    card {
      id
      nickname
      __typename
    }
    referralCode
    createdAt
    updatedAt
    orders {
      items {
        id
        tenantID
        facilityID
        date
        time
        address {
          tenantID
          addressLine1
          addressLine2
          city
          state
          zip
          specialInstructions
          building
          parking
          __typename
        }
        jobType
        status
        driver
        needHelp
        needPack
        moverOption
        orderItems
        movingTime
        movingFee
        isInitialOrder
        chosenSlotPaid
        chosenSlotPrice
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTenantMutationVariables,
  APITypes.DeleteTenantMutation
>;
export const createLead = /* GraphQL */ `mutation CreateLead(
  $input: CreateLeadInput!
  $condition: ModelLeadConditionInput
) {
  createLead(input: $input, condition: $condition) {
    id
    facilityID
    name
    phone
    email
    dateCreated
    lastContacted
    contactMethod
    followUpAt
    source
    sourceCustom
    anticipatedDate
    notes
    status
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLeadMutationVariables,
  APITypes.CreateLeadMutation
>;
export const updateLead = /* GraphQL */ `mutation UpdateLead(
  $input: UpdateLeadInput!
  $condition: ModelLeadConditionInput
) {
  updateLead(input: $input, condition: $condition) {
    id
    facilityID
    name
    phone
    email
    dateCreated
    lastContacted
    contactMethod
    followUpAt
    source
    sourceCustom
    anticipatedDate
    notes
    status
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLeadMutationVariables,
  APITypes.UpdateLeadMutation
>;
export const deleteLead = /* GraphQL */ `mutation DeleteLead(
  $input: DeleteLeadInput!
  $condition: ModelLeadConditionInput
) {
  deleteLead(input: $input, condition: $condition) {
    id
    facilityID
    name
    phone
    email
    dateCreated
    lastContacted
    contactMethod
    followUpAt
    source
    sourceCustom
    anticipatedDate
    notes
    status
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLeadMutationVariables,
  APITypes.DeleteLeadMutation
>;
export const createLedgerEntry = /* GraphQL */ `mutation CreateLedgerEntry(
  $input: CreateLedgerEntryInput!
  $condition: ModelLedgerEntryConditionInput
) {
  createLedgerEntry(input: $input, condition: $condition) {
    id
    facilityID
    name
    tenantID
    date
    amount
    type
    month
    notes
    paid
    rentPortionCents
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLedgerEntryMutationVariables,
  APITypes.CreateLedgerEntryMutation
>;
export const updateLedgerEntry = /* GraphQL */ `mutation UpdateLedgerEntry(
  $input: UpdateLedgerEntryInput!
  $condition: ModelLedgerEntryConditionInput
) {
  updateLedgerEntry(input: $input, condition: $condition) {
    id
    facilityID
    name
    tenantID
    date
    amount
    type
    month
    notes
    paid
    rentPortionCents
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLedgerEntryMutationVariables,
  APITypes.UpdateLedgerEntryMutation
>;
export const deleteLedgerEntry = /* GraphQL */ `mutation DeleteLedgerEntry(
  $input: DeleteLedgerEntryInput!
  $condition: ModelLedgerEntryConditionInput
) {
  deleteLedgerEntry(input: $input, condition: $condition) {
    id
    facilityID
    name
    tenantID
    date
    amount
    type
    month
    notes
    paid
    rentPortionCents
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLedgerEntryMutationVariables,
  APITypes.DeleteLedgerEntryMutation
>;
export const createOrder = /* GraphQL */ `mutation CreateOrder(
  $input: CreateOrderInput!
  $condition: ModelOrderConditionInput
) {
  createOrder(input: $input, condition: $condition) {
    id
    tenantID
    facilityID
    date
    time
    address {
      tenantID
      addressLine1
      addressLine2
      city
      state
      zip
      specialInstructions
      building
      parking
      __typename
    }
    jobType
    status
    driver
    needHelp
    needPack
    moverOption
    orderItems
    movingTime
    movingFee
    isInitialOrder
    chosenSlotPaid
    chosenSlotPrice
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateOrderMutationVariables,
  APITypes.CreateOrderMutation
>;
export const updateOrder = /* GraphQL */ `mutation UpdateOrder(
  $input: UpdateOrderInput!
  $condition: ModelOrderConditionInput
) {
  updateOrder(input: $input, condition: $condition) {
    id
    tenantID
    facilityID
    date
    time
    address {
      tenantID
      addressLine1
      addressLine2
      city
      state
      zip
      specialInstructions
      building
      parking
      __typename
    }
    jobType
    status
    driver
    needHelp
    needPack
    moverOption
    orderItems
    movingTime
    movingFee
    isInitialOrder
    chosenSlotPaid
    chosenSlotPrice
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateOrderMutationVariables,
  APITypes.UpdateOrderMutation
>;
export const deleteOrder = /* GraphQL */ `mutation DeleteOrder(
  $input: DeleteOrderInput!
  $condition: ModelOrderConditionInput
) {
  deleteOrder(input: $input, condition: $condition) {
    id
    tenantID
    facilityID
    date
    time
    address {
      tenantID
      addressLine1
      addressLine2
      city
      state
      zip
      specialInstructions
      building
      parking
      __typename
    }
    jobType
    status
    driver
    needHelp
    needPack
    moverOption
    orderItems
    movingTime
    movingFee
    isInitialOrder
    chosenSlotPaid
    chosenSlotPrice
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteOrderMutationVariables,
  APITypes.DeleteOrderMutation
>;
export const createStoragePlan = /* GraphQL */ `mutation CreateStoragePlan(
  $input: CreateStoragePlanInput!
  $condition: ModelStoragePlanConditionInput
) {
  createStoragePlan(input: $input, condition: $condition) {
    id
    facilityID
    type
    minStay
    photo
    size
    price
    ft
    description
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateStoragePlanMutationVariables,
  APITypes.CreateStoragePlanMutation
>;
export const updateStoragePlan = /* GraphQL */ `mutation UpdateStoragePlan(
  $input: UpdateStoragePlanInput!
  $condition: ModelStoragePlanConditionInput
) {
  updateStoragePlan(input: $input, condition: $condition) {
    id
    facilityID
    type
    minStay
    photo
    size
    price
    ft
    description
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateStoragePlanMutationVariables,
  APITypes.UpdateStoragePlanMutation
>;
export const deleteStoragePlan = /* GraphQL */ `mutation DeleteStoragePlan(
  $input: DeleteStoragePlanInput!
  $condition: ModelStoragePlanConditionInput
) {
  deleteStoragePlan(input: $input, condition: $condition) {
    id
    facilityID
    type
    minStay
    photo
    size
    price
    ft
    description
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteStoragePlanMutationVariables,
  APITypes.DeleteStoragePlanMutation
>;
export const createExternalRef = /* GraphQL */ `mutation CreateExternalRef(
  $input: CreateExternalRefInput!
  $condition: ModelExternalRefConditionInput
) {
  createExternalRef(input: $input, condition: $condition) {
    id
    facilityID
    provider
    entity
    binsID
    externalID
    receiptNumber
    shadow
    raw
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateExternalRefMutationVariables,
  APITypes.CreateExternalRefMutation
>;
export const updateExternalRef = /* GraphQL */ `mutation UpdateExternalRef(
  $input: UpdateExternalRefInput!
  $condition: ModelExternalRefConditionInput
) {
  updateExternalRef(input: $input, condition: $condition) {
    id
    facilityID
    provider
    entity
    binsID
    externalID
    receiptNumber
    shadow
    raw
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateExternalRefMutationVariables,
  APITypes.UpdateExternalRefMutation
>;
export const deleteExternalRef = /* GraphQL */ `mutation DeleteExternalRef(
  $input: DeleteExternalRefInput!
  $condition: ModelExternalRefConditionInput
) {
  deleteExternalRef(input: $input, condition: $condition) {
    id
    facilityID
    provider
    entity
    binsID
    externalID
    receiptNumber
    shadow
    raw
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteExternalRefMutationVariables,
  APITypes.DeleteExternalRefMutation
>;
export const createPmsSyncJob = /* GraphQL */ `mutation CreatePmsSyncJob(
  $input: CreatePmsSyncJobInput!
  $condition: ModelPmsSyncJobConditionInput
) {
  createPmsSyncJob(input: $input, condition: $condition) {
    id
    facilityID
    provider
    op
    binsID
    mode
    queueKey
    payload
    request
    response
    status
    errorClass
    lastError
    attempts
    createdAtISO
    nextAttemptAtISO
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePmsSyncJobMutationVariables,
  APITypes.CreatePmsSyncJobMutation
>;
export const updatePmsSyncJob = /* GraphQL */ `mutation UpdatePmsSyncJob(
  $input: UpdatePmsSyncJobInput!
  $condition: ModelPmsSyncJobConditionInput
) {
  updatePmsSyncJob(input: $input, condition: $condition) {
    id
    facilityID
    provider
    op
    binsID
    mode
    queueKey
    payload
    request
    response
    status
    errorClass
    lastError
    attempts
    createdAtISO
    nextAttemptAtISO
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePmsSyncJobMutationVariables,
  APITypes.UpdatePmsSyncJobMutation
>;
export const deletePmsSyncJob = /* GraphQL */ `mutation DeletePmsSyncJob(
  $input: DeletePmsSyncJobInput!
  $condition: ModelPmsSyncJobConditionInput
) {
  deletePmsSyncJob(input: $input, condition: $condition) {
    id
    facilityID
    provider
    op
    binsID
    mode
    queueKey
    payload
    request
    response
    status
    errorClass
    lastError
    attempts
    createdAtISO
    nextAttemptAtISO
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePmsSyncJobMutationVariables,
  APITypes.DeletePmsSyncJobMutation
>;
